<template>
    <div class="popup__content-form active">
        <form @submit.prevent="debounce(validate)" class="form">
            <div class="form__inputs">
                <div class="default-input">
                    <input @input="reset" v-model="email" class="default-input__input"
                           :class="{'default-input__input--error':errors.some(er => er.code === 5)}" type="text" placeholder="E-mail*">
                    <span v-if="errors.some(er => er.code === 5)" class="default-input__error"></span>
                </div>
                <div class="default-input">
                    <input @input="reset" v-model="password" class="default-input__input"
                           :class="{'default-input__input--error':errors.some(er => er.code === 2)}"
                           type="password" placeholder="Пароль*">
                    <span v-if="errors.some(er => er.code === 2)" class="default-input__error"></span>
                </div>
                <div style="display: none">
                    <vue-recaptcha
                        ref="recaptcha"
                        size="invisible"
                        :sitekey="this.site_key"
                        @verify="sendData"
                        @expired="onCaptchaExpired"
                    />
                </div>
            </div>
            <div class="form__submit">
                <input class="form__submit-btn btn" type="submit" value="Войти"/>
                <div class="form__submit-text">Нажимая кнопку, Вы даете информированное согласие на
                    <a target="_blanc" :href="modulePolicy.file_src">обработку своих персональных данных</a>
                </div>
                <div class="form__submit-link" data-popup="#forgot">Забыли пароль?</div>
            </div>
        </form>
    </div>
</template>

<script>
import recaptcha from "@/components/mixins/recaptcha";
import errors from "@/components/mixins/errors";
import tools from "@/components/mixins/tools";
import { mapState } from 'vuex';
import { reachGoal as ymReachGoal } from "@/modules/metrika";
export default {
    name: "AuthForm",
    data() {
        return {
            email   : '',
            password: '',
        }
    },
    computed: {
        ... mapState([
            'modulePolicy'
        ]),
    },
    mixins  : [recaptcha, errors, tools],
    methods : {
        sendData(recaptchaToken) {
            this.reset();
            let formData = new FormData();
            formData.append('email', this.email);
            formData.append('password', this.password);
            formData.append('token', recaptchaToken);
            fetch("/api/user/auth/", {method: 'POST', body: formData})
                .then(response => response.json())
                .then(async resp => {
                    if(resp.success !== true)
                    {
                        let errs = JSON.parse(resp.message);
                        this.parse(errs);
                    }
                    else {
                        ymReachGoal('authorization');
                        location.href = '/personal/private/';
                    }
                });
        },
    }
}
</script>

<style scoped>

</style>
